<template>
  <el-dialog title="下游报价单" :visible.sync="dialogIsShow" width="750px" :close-on-click-modal="false" ref="dialog"
    append-to-body>
    <div class="dia_body">
      <div class="canvasImg" ref="canvasImg">
        <table border="0">
          <tr>
            <th colspan="7" style="height: 50px;font-size: 24px;font-weight: bold;position: relative;">报价单
            </th>
          </tr>
          <tr>
            <th>ID</th>
            <td colspan="2">{{ (jobBaseInfo && jobBaseInfo.Id) }}</td>
            <th>项目名称</th>
            <td colspan="2">{{ (jobBaseInfo && jobBaseInfo.Title) }}</td>
          </tr>
          <tr>
            <th>工程师/服务商</th>
            <td colspan="2">{{ (info && info.ReceiverUserName) }}</td>
            <th>客服</th>
            <td colspan="2">{{ (info && info.AdminUserName) }}</td>
            <!-- <td colspan="2">--</td>  -->
          </tr>
          <tr>
            <th>地址</th>
            <td colspan="2" style="text-align: left;">{{ (jobBaseInfo && jobBaseInfo.JobAddress) }}</td>
            <th>日期</th>
            <td colspan="2">{{ (info && info.CreateDate) }}</td>
          </tr>

          <tr>
            <th>服务内容</th>
            <td colspan="7" style="text-align: left;">
              <div v-html="(jobDetailInfo && jobDetailInfo.Content)"></div>
            </td>
          </tr>
          <tr>
            <th>计费项</th>
            <th>单价</th>
            <!-- <th>预估天数</th> -->
            <th>单位</th>
            <th>数量</th>
            <th>总价</th>
          </tr>
          <tr>
            <td>人工费</td>
            <td>
              ￥{{ (info && info.ManHourPrice) }}
            </td>
            <td>项</td>
            <td> {{ (info && info.ManHourCount) }} </td>
            <td>
              ￥{{ (info && info.ManHourAmount) }}
            </td>
          </tr>
          <tr>
            <td>交通费</td>
            <td>
              ￥{{ (info && info.TrafficPrice) }}
            </td>
            <td>项 </td>
            <td>
              {{ (info && info.TrafficCount) }}
            </td>

            <td>
              ￥{{ (info && info.TrafficAmount) }}
            </td>
          </tr>
          <tr>
            <td>材料费</td>
            <td>
              ￥{{ (info && info.MateriaPrice) }}
            </td>
            <td>项 </td>
            <td>
              {{ (info && info.MateriaCount) }}
            </td>
            <td>
              ￥{{ (info && info.MateriaAmount) }}
            </td>
          </tr>
          <tr>
            <td>其他费用</td>
            <td> ￥{{ (info && info.OtherPrice) }} </td>
            <td>项 </td>
            <td>
              {{ (info && info.OtherCount) }}
            </td>
            <td>
              ￥{{ (info && info.OtherAmount) }}
            </td>
          </tr>
          <tr>
            <!-- <th>合计(不含税{{ info&&info.ReceiverUserType==1?'8':"6" }}%)</th> -->
            <th>合计(不含税)</th>
            <td colspan="2" style="text-align: left;">
              ￥{{ (info && info.TotalAmount) }}
            </td>
            <th>计费类别</th>
            <td style="padding:10px 5px;">
              {{ ((info && info.BillType == 0) ? "按天" : "整包") }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="copyImg">复制图片</el-button>

      <el-button type="primary" size="small" @click="dialogIsShow = false;">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import html2canvas from 'html2canvas';
import { JobUpOffer, JobDownOffer, GetJobSupaiSalePerson } from "@/service/job";
export default {
  data() {
    return {
      dialogIsShow: false,
      jobId: 0,

      info: null,//报价信息，
      jobOtherInfo: null,
      jobBaseInfo: null,
      jobDetailInfo: null,
    };
  },
  created() { },

  methods: {
    openDia(info, jobOtherInfo, jobBaseInfo, jobDetailInfo) {
      this.dialogIsShow = true;

      this.info = info;
      this.jobOtherInfo = jobOtherInfo;
      this.jobBaseInfo = jobBaseInfo;
      this.jobDetailInfo =Object.assign({}, jobDetailInfo);
      if(this.jobDetailInfo&&this.jobDetailInfo.Content) {
        this.jobDetailInfo.Content=this.jobDetailInfo.Content.replace(/\r/g,'<br/>');
      }
      console.log("this.dialogIsShow:" + this.dialogIsShow);
    },
    //复制图片
    async copyImg() {
      try {
        const canvas = await html2canvas(this.$refs.canvasImg) // 在这里，将需要转换成图片的部分作为参数传入html2canvas
        const image = canvas.toDataURL() // 将生成的canvas转换为DataURL格式
        this.imgUrl = image;
        console.log(image) // 可以将image自行存储

        const data = await fetch(this.imgUrl);
        const blob = await data.blob();

        await navigator.clipboard.write([
          new ClipboardItem({
            [blob.type]: blob,
          }),
        ]);

        return this.$message.success('已复制')

      } catch (e) {
        throw new Error(e)
      }

    },


  }
};
</script>

<style scoped lang="scss">
.dia_body {
  input[aria-hidden="true"] {
    display: none !important;
  }
    .canvasImg{
  // border: 1px solid red;
  padding:5px;
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }

  table th {
    width: 115px;
    // border: 0.5px solid black;
    text-align: center;
    padding: 5px;
    vertical-align: middle;
    border: 1px solid #ebeef5;
    //  border: 1px solid #ebeef5;
  }

  table td {
    padding: 5px;
    text-align: center;
    border: 1px solid #ebeef5;
  }

  img.logo {
    width: 150px;
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
</style>